import moment from 'moment';
import React from 'react'
import { LoadingSpinner } from '../../../components';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';

const ReportByPurchasedMobile = (props) => {
    const { isLoading, showData, filter, handleOpen } = props;

    return (
        <div>
            {
                isLoading ? <LoadingSpinner /> :
                    showData && showData.length > 0 ? (
                        <div className="flex flex-col mt-2 px-2 space-y-3">
                            {showData.map((item, index) => {
                                const isMix = filter.value === 2;
                                return (
                                    <div
                                        key={index}
                                        className="bg-white rounded-lg shadow-md border-l-4 border-background p-4"
                                    >
                                        <div className="flex justify-between gap-2">
                                            <div className="flex-1">
                                                <div className='flex justify-between items-center'>
                                                    <div>
                                                        <p className="text-base font-bold text-yellow-600">
                                                            {isMix
                                                                ? item.voucherNo
                                                                : item.isHome
                                                                    ? item.homeTeam
                                                                    : item.isAway
                                                                        ? item.awayTeam
                                                                        : item.isOver
                                                                            ? "Goal Over"
                                                                            : "Goal Under"}
                                                        </p>

                                                        <p className="text-xs text-gray-400 mt-1">
                                                            {moment(item.createdAt).format("DD-MM-YYYY hh:mm A")}
                                                        </p>
                                                    </div>
                                                    <div className="flex flex-col items-end justify-start">
                                                        <span className="text-xs text-customFontVoilet font-semibold">
                                                            Purchased Amount
                                                        </span>
                                                        <span className="text-base font-bold text-gray-800">
                                                            {item.betAmount.toLocaleString("en-US")}
                                                        </span>
                                                    </div>
                                                </div>
                                                {isMix ? (
                                                    <>
                                                        <p className="text-sm font-medium text-customFontLightGreen mt-3">
                                                            Mix Count: {item.teamCount}
                                                        </p>
                                                        {item.remark && (
                                                            <p className="text-sm text-gray-600 mt-2">
                                                                <span className="font-semibold">Remark:</span>{" "}
                                                                {item.remark}
                                                            </p>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="mt-3 space-y-1">
                                                            <p className="text-xs font-semibold text-gray-500">
                                                                {item.leagueName}
                                                            </p>
                                                            <p className="text-sm font-bold text-customFontLightGreen">
                                                                {item.homeTeam} vs {item.awayTeam}
                                                            </p>
                                                            <p className="text-xs text-gray-500">
                                                                {moment(item.eventTime, "YYYY-MM-DD HH:mm:ss").format(
                                                                    "DD-MM-YYYY HH:mm a"
                                                                )}
                                                            </p>
                                                        </div>
                                                        {item.remark && (
                                                            <p className="text-sm text-gray-600 mt-2">
                                                                <span className="font-semibold">Remark:</span>{" "}
                                                                {item.remark}
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className='flex justify-between items-center mt-3'>
                                            <button 
                                            className='bg-customFontGreen px-2 py-1 text-white rounded-md flex items-center gap-1 text-sm'
                                             onClick={() => handleOpen('edit', item)}
                                            >
                                                 <FaEdit className="text-sm" /> Edit
                                            </button>
                                            <button 
                                            className='bg-customFontRed px-2 py-1 text-white rounded-md flex items-center gap-1 text-sm'
                                            onClick={() => handleOpen('delete', item)}
                                            >
                                                 <FaTrashAlt className="text-sm" /> Delete
                                            </button>
                                        </div>   
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="flex justify-center items-center h-60 text-gray-400">
                            <p>No data available</p>
                        </div>
                    )}

        </div>
    )
}

export default ReportByPurchasedMobile;